import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/plugins/axios.js';
// import moment from '@/plugins/Moment.js'

import EditMsModalPanel from '~/components/mainPage/EditMsModalPanel.vue';

export default {
  name: 'module-session-list',
  components: {
    EditMsModalPanel: EditMsModalPanel
  },
  data: function data() {
    return {
      isAdmin: this.$store.state.authUser.flag === 'Admin', // will be retrived from backend,
      editMsModalInfo: {
        title: '',
        content: ''
      }
    };
  },

  // filters:{
  //   localTime: function(timeRaw){
  //     let dateString = moment(timeRaw, 'YYYY-MM-DD HH:mm');
  //     return dateString ;
  //   }
  // },
  computed: {
    // parsedLocalTime(timeRaw){
    //   return this.parseTime(timeRaw);
    // }
  },
  methods: {
    popeditMsModal: function popeditMsModal(ms, button) {
      console.log('\n\n ======= edit Modal popup ======= \n', ms, '\n ============');
      this.$root.$emit('bv::show::modal', 'editMsModal', button);
      this.$store.commit('setModuleSession', ms);
    },

    // ========== Updating Module Session Info ==========
    updateModuleSessionInfo: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(moduleInfo) {
        var adminActorId, currentModuleSessionId, msInfoReturned;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ======= Emit from modal and Received@Cal-view ========\n', moduleInfo, '\n ===================');
                console.log('\n\n ======= Update MS info panel $store.state ======== \n', this.$store.state.currentModuleSession, '\n ==========');

                adminActorId = this.$store.state.authUserActorId;
                currentModuleSessionId = this.$store.state.currentModuleSession.id;
                _context.next = 6;
                return axios.post('/moduleSession/updateModuleSession', { moduleInfo: moduleInfo, adminActorId: adminActorId, currentModuleSessionId: currentModuleSessionId });

              case 6:
                msInfoReturned = _context.sent.data;


                if (msInfoReturned.hasOwnProperty('moduleSession')) {
                  console.log('\n\n ======= Update MS info panel ======== \n', msInfoReturned, '\n =========');
                  alert('Successful');
                } else {
                  console.log('\n\n ======== msInfoReturned =======\n', msInfoReturned, '\n==============');
                  alert(msInfoReturned);
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateModuleSessionInfo(_x) {
        return _ref.apply(this, arguments);
      }

      return updateModuleSessionInfo;
    }(),
    removeModuleSession: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ms, button) {
        var removeInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n ======= Remove ======= \n', ms, '\n ============');
                this.$store.commit('removeModuleSessionList', ms);

                _context2.next = 4;
                return axios.post('/moduleSession/removeModuleSession', { ms: ms });

              case 4:
                removeInfo = _context2.sent.data;


                console.log('\n\n =========== Remove Module Session Info ============\n', removeInfo, '\n --------------------------');

                this.emitRefreshEvent();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeModuleSession(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return removeModuleSession;
    }(),


    // ======= emit refresh event =======
    emitRefreshEvent: function emitRefreshEvent() {
      this.$emit('refreshMsList');
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/ModuleSessionList.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/mainPage/ModuleSessionList.vue
// module chunks = 6